const RotateLeftIcon = ({ color = "rgb(var(--color-brand))" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.59157 4.23333C8.31657 4.01667 9.11657 3.875 9.9999 3.875C13.9916 3.875 17.2249 7.10833 17.2249 11.1C17.2249 15.0917 13.9916 18.325 9.9999 18.325C6.00824 18.325 2.7749 15.0917 2.7749 11.1C2.7749 9.61667 3.2249 8.23333 3.99157 7.08333"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.55811 4.43366L8.96644 1.66699"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.55811 4.43359L9.36644 6.48359"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RotateLeftIcon;
